/**
 * 股东信息模块
 */

import React, { FC, useMemo, useState } from 'react';
import { ProDetailList } from '@bedrock/eed-react';
import { ChevronDown, ChevronUp } from '@bedrock/icons-react';
import { Button, Tag } from '@bedrock/components';
import {
  FormModule,
  FormItemActualControllerDetailList,
  FormItemShareholdingRatio,
  FormItemSubscribedCapital,
  ClickableName,
} from '@purchase/supplier';
import { useExecutiveRelationModal } from '../../Qcc/useExecutiveRelationModal';

const ShareholderModule: FC<{
  formDetail: any;
}> = ({ formDetail }) => {
  const [showHistoryShareholders, setShowHistoryShareholders] = useState(false);
  const { openModal, modalElement, hasRelationData } =
    useExecutiveRelationModal(formDetail);

  const vendorShareholderCount = useMemo(
    () => formDetail?.vendorShareholderInfos?.length ?? 0,
    [formDetail]
  );
  const hasHistoryShareholders = useMemo(
    () => (formDetail?.vendorQccHistoryShareholderInfos?.length ?? 0) > 0,
    [formDetail]
  );

  return (
    <>
      <FormModule
        title="股东信息"
        titleCount={vendorShareholderCount}
        proCardProps={{
          expandable: true,
          defaultExpanded: vendorShareholderCount > 0,
        }}
      >
        <FormItemActualControllerDetailList
          name={
            showHistoryShareholders
              ? 'vendorShareholderWithHistoryInfos'
              : 'vendorShareholderInfos'
          }
          fieldProps={{ scroll: { x: 1120 } }}
        >
          <ProDetailList.Item
            label="#"
            name="#"
            meta={{ columnProps: { width: 50, fixed: true } }}
          >
            {(value, record, index) => index + 1}
          </ProDetailList.Item>
          <ProDetailList.Item
            label="股东名称"
            name="shareholderName"
            meta={{
              columnProps: {
                width: 200,
                fixed: true,
              },
            }}
          >
            {(value, record) => (
              <span className="flex items-center gap-1">
                <ClickableName
                  className="font-semibold"
                  name={value}
                  clickable={hasRelationData(value)}
                  onClick={() => openModal({ name: value })}
                />
                {record?.isHistory && (
                  <Tag color="light-grey" text="历史" size="xSmall" />
                )}
              </span>
            )}
          </ProDetailList.Item>
          <FormItemShareholdingRatio
            label="股权比例"
            name="shareholdingRatio"
          />
          <FormItemSubscribedCapital
            label="认缴出资额（万）"
            name="subscribedCapital"
          />
        </FormItemActualControllerDetailList>

        {/* 展开/收起历史股东 */}
        {hasHistoryShareholders && (
          <div className="mt-2 text-xs text-color-2">
            <Button
              type="link"
              onClick={() => setShowHistoryShareholders((prev) => !prev)}
              suffixIcon={
                showHistoryShareholders ? <ChevronUp /> : <ChevronDown />
              }
            >
              {showHistoryShareholders ? '收起历史' : '展开历史'}
            </Button>
          </div>
        )}
      </FormModule>
      {modalElement}
    </>
  );
};

export default ShareholderModule;
